import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-452a05f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "contact-form" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-line" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, [
    /*#__PURE__*/_createTextVNode("Drop Us "),
    /*#__PURE__*/_createElementVNode("span", { class: "color" }, "A Line")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "title-text" }, " Simply let us know how we can help you! ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactForm = _resolveComponent("ContactForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_ContactForm)
    ])
  ]))
}